module.exports = __webpack_public_path__ + "images/822c6d4bdc99feae4995cb12b9e587d4.jpg";